/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'

export function deleteMandateFileById (id: number) {
  return rest.delete(`/api/mandate-files/${id}`)
}

export function downloadMandateFileById (id: number) {
  return rest.get(`/api/mandate-files/${id}/file`)
    .then(handleBlobResponse)
}

export function fetchMandateFileByMandateId (id: number): Promise<MandateFile> {
  return rest.get(`/api/mandates/${id}/file/meta`)
    .then((resp) => resp.json())
}

export function uploadMandateFile (file: File, mandateId: number) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('mandateId', String(mandateId))
  return rest.put(`/api/mandates/${mandateId}/file`, { body: fd })
    .then((resp) => resp.json())
}
